import React from "react";
import "../components/base.css";
import mixpanel from "mixpanel-browser";
// import clevertap from "clevertap-web-sdk";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);
  }

   handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      mixpanel.track("error-page-shown");
      // clevertap.event.push("error-page-shown");
      // You can render any custom fallback UI
      return (
        <body className="error">
          <h1>Something went wrong!</h1>
          <button
            onClick={this.handleReset}
            style={{
              marginTop: 16,
              padding: "8px 16px",
              backgroundColor: "#851d1e",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Reset UI
          </button>
        </body>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
